<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex lg12 sm12 xs12>
        <v-card class="app-card" elevation="0">
          <v-card-title class="app-card-title mb-0">
            <h4 class="text">
              <span class="mr-2">Detalhes do Pedido</span>
              <span v-if="order">#{{ order.id }} | </span>
              <span v-if="order">
                <v-icon>business</v-icon>
                {{ getCompanyInfo(order.company) }}
              </span>
            </h4>
            
            <v-spacer />                 
            <div v-if="this.order">       
              <v-btn v-if="this.order.pendenciable" @click="doPending" depressed color="warning" class="ml-2">
                Pendenciar
              </v-btn>              
              <OrderRefusalButton 
                v-if="this.order.refusable" 
                :id="this.order.id"
                @close="closeRefuseModal"
              />
              <v-btn v-if="this.order.approvable" @click="doApprove" depressed color="success" class="ml-2">
                Deferir
              </v-btn>
              <v-btn v-if="this.order.analysable" @click="doAnalyse" depressed color="success" 
                class="mr-2">
                Analisar
              </v-btn> 
            </div>
          </v-card-title>
          <v-card-text class="app-card-content">
            <OrderDetailHeader 
              v-if="order"
              :order="order" 
            />             

            <OrderDetailTabs 
              v-if="order"
              :order="order" 
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import OrderDetailHeader from './components/OrderDetailHeader.vue';
  import OrderDetailTabs from './components/OrderDetailTabs.vue';
  import OrderRefusalButton from './components/OrderRefusalButton.vue';

  export default {
    name: 'OrderDetail',

    components: {
      OrderDetailHeader,
      OrderDetailTabs,
      OrderRefusalButton
    },

    data: () => ({      
    }),

    computed: {
      ...mapState('pedido', { order: state => state.detail.data })
    },

    watch: {
      '$route.params.id'() {
        this.fetchOrder();
      }
    },

    mounted() {
      this.fetchOrder();
    },

    destroyed() {
      this.clear();
    },

    methods: {  
      fetchOrder() {
        if (!this.$route.params.id) return;

        this.fetch(this.$route.params.id);
      },

      doAnalyse() {
        this.analyse(this.$route.params.id);        
      },

      doApprove() {
        this.approve(this.$route.params.id);        
      },

      doPending() {
        this.pending(this.$route.params.id);  
      },

      closeRefuseModal(event) {
        if(!event.updated) return;

        this.fetchOrder();
      },

      getCompanyInfo(company) {
        if(!company) return '';

        return `${company.name} / CNPJ: ${company.cnpj}`;
      },

      ...mapActions('pedido', { 
        fetch: 'SHOW', 
        clear: 'CLEAR_DETAIL',
        analyse: 'ANALYSE',
        approve: 'APPROVE',
        refuse: 'REFUSE',
        pending: 'PENDING',
      }),
    },
  };
</script>

<style lang="scss" scoped>
.isLoading {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  margin: 0px;
}
</style>
